import {
  getShopsData,
  downloadShopData,
  getShopDetailData,
  addShopData,
  editShopData,
  editShopBankAccountData,
  releaseShopData,
  deleteShopData,
  addShopImageData,
  downloadQrCodeData,
  countShopEmailData,
  addRelationShopData,
  addUnRelationShopData,
  getZipCodeData,
  getShopsDataEs,
  getPaymentSummaryShopData,
  sendMailPaymentDetailMonthData,
  downloadShopEsData,
  linkPaymentShopData,
  getShopMenuViewOrderData,
  getGochiTipSummaryData,
  getGochiTipUrlData,
  confirmInvoiceShopData,
  getInvoiceHistoryShopData,
  getInvoiceShopData,
  listBatchShopData,
  validateBatchShopData,
  batchShopImportFileData,
  sendShopReportData,
  getSettingGochiKidShopData,
  getReportShopData,
  deleteSettingGochiKidShopData,
  updateSettingGochiKidShopData,
  updateGochiKidFlagShopData,
  updateShopSettingGochiKidUnlimitData,
  updateAllowGapPaymentData
} from '../libs/apis/ShopApi';

export const GET_SHOPS_REQUEST = 'GET_SHOPS_REQUEST';
export const GET_SHOPS_SUCCESS = 'GET_SHOPS_SUCCESS';
export const GET_SHOPS_FAILURE = 'GET_SHOPS_FAILURE';

export const DOWNLOAD_SHOP_REQUEST = 'DOWNLOAD_SHOP_REQUEST';
export const DOWNLOAD_SHOP_SUCCESS = 'DOWNLOAD_SHOP_SUCCESS';
export const DOWNLOAD_SHOP_FAILURE = 'DOWNLOAD_SHOP_FAILURE';

export const DOWNLOAD_SHOP_ES_REQUEST = 'DOWNLOAD_SHOP_ES_REQUEST';
export const DOWNLOAD_SHOP_ES_SUCCESS = 'DOWNLOAD_SHOP_ES_SUCCESS';
export const DOWNLOAD_SHOP_ES_FAILURE = 'DOWNLOAD_SHOP_ES_FAILURE';

export const GET_SHOP_DETAIL_REQUEST = 'GET_SHOP_DETAIL_REQUEST';
export const GET_SHOP_DETAIL_SUCCESS = 'GET_SHOP_DETAIL_SUCCESS';
export const GET_SHOP_DETAIL_FAILURE = 'GET_SHOP_DETAIL_FAILURE';

export const ADD_SHOP_REQUEST = 'ADD_SHOP_REQUEST';
export const ADD_SHOP_SUCCESS = 'ADD_SHOP_SUCCESS';
export const ADD_SHOP_FAILURE = 'ADD_SHOP_FAILURE';

export const EDIT_SHOP_REQUEST = 'EDIT_SHOP_REQUEST';
export const EDIT_SHOP_SUCCESS = 'EDIT_SHOP_SUCCESS';
export const EDIT_SHOP_FAILURE = 'EDIT_SHOP_FAILURE';

export const EDIT_SHOP_BANK_ACCOUNT_REQUEST = 'EDIT_SHOP_BANK_ACCOUNT_REQUEST';
export const EDIT_SHOP_BANK_ACCOUNT_SUCCESS = 'EDIT_SHOP_BANK_ACCOUNT_SUCCESS';
export const EDIT_SHOP_BANK_ACCOUNT_FAILURE = 'EDIT_SHOP_BANK_ACCOUNT_FAILURE';

export const RELEASE_SHOP_REQUEST = 'RELEASE_SHOP_REQUEST';
export const RELEASE_SHOP_SUCCESS = 'RELEASE_SHOP_SUCCESS';
export const RELEASE_SHOP_FAILURE = 'RELEASE_SHOP_FAILURE';

export const DELETE_SHOP_REQUEST = 'DELETE_SHOP_REQUEST';
export const DELETE_SHOP_SUCCESS = 'DELETE_SHOP_SUCCESS';
export const DELETE_SHOP_FAILURE = 'DELETE_SHOP_FAILURE';

export const ADD_SHOP_IMAGE_REQUEST = 'ADD_SHOP_IMAGE_REQUEST';
export const ADD_SHOP_IMAGE_SUCCESS = 'ADD_SHOP_IMAGE_SUCCESS';
export const ADD_SHOP_IMAGE_FAILURE = 'ADD_SHOP_IMAGE_FAILURE';

export const DOWNLOAD_QRCODE_REQUEST = 'DOWNLOAD_QRCODE_REQUEST';
export const DOWNLOAD_QRCODE_SUCCESS = 'DOWNLOAD_QRCODE_SUCCESS';
export const DOWNLOAD_QRCODE_FAILURE = 'DOWNLOAD_QRCODE_FAILURE';

export const COUNT_SHOP_EMAIL_REQUEST = 'COUNT_SHOP_EMAIL_REQUEST';
export const COUNT_SHOP_EMAIL_SUCCESS = 'COUNT_SHOP_EMAIL_SUCCESS';
export const COUNT_SHOP_EMAIL_FAILURE = 'COUNT_SHOP_EMAIL_FAILURE';

export const ADD_RELATION_SHOP_REQUEST = 'ADD_RELATION_SHOP_REQUEST';
export const ADD_RELATION_SHOP_SUCCESS = 'ADD_RELATION_SHOP_SUCCESS';
export const ADD_RELATION_SHOP_FAILURE = 'ADD_RELATION_SHOP_FAILURE';

export const DELETE_RELATION_SHOP_REQUEST = 'DELETE_RELATION_SHOP_REQUEST';
export const DELETE_RELATION_SHOP_SUCCESS = 'DELETE_RELATION_SHOP_SUCCESS';
export const DELETE_RELATION_SHOP_FAILURE = 'DELETE_RELATION_SHOP_FAILURE';

export const GET_ZIPCODE_REQUEST = 'GET_ZIPCODE_REQUEST';
export const GET_ZIPCODE_SUCCESS = 'GET_ZIPCODE_SUCCESS';
export const GET_ZIPCODE_FAILURE = 'GET_ZIPCODE_FAILURE';

export const LINK_PAYMENT_SHOP_REQUEST = 'LINK_PAYMENT_SHOP_REQUEST';
export const LINK_PAYMENT_SHOP_SUCCESS = 'LINK_PAYMENT_SHOP_SUCCESS';
export const LINK_PAYMENT_SHOP_FAILURE = 'LINK_PAYMENT_SHOP_FAILURE';

export const GET_PAYMENT_SUMMARY_SHOP_REQUEST =
  'GET_PAYMENT_SUMMARY_SHOP_REQUEST';
export const GET_PAYMENT_SUMMARY_SHOP_SUCCESS =
  'GET_PAYMENT_SUMMARY_SHOP_SUCCESS';
export const GET_PAYMENT_SUMMARY_SHOP_FAILURE =
  'GET_PAYMENT_SUMMARY_SHOP_FAILURE';

export const SEND_MAIL_PAYMENT_DETAIL_MONTH_REQUEST =
  'SEND_MAIL_PAYMENT_DETAIL_MONTH_REQUEST';
export const SEND_MAIL_PAYMENT_DETAIL_MONTH_SUCCESS =
  'SEND_MAIL_PAYMENT_DETAIL_MONTH_SUCCESS';
export const SEND_MAIL_PAYMENT_DETAIL_MONTH_FAILURE =
  'SEND_MAIL_PAYMENT_DETAIL_MONTH_FAILURE';

export const GET_SHOP_MENU_VIEW_ORDER_REQUEST =
  'GET_SHOP_MENU_VIEW_ORDER_REQUEST';
export const GET_SHOP_MENU_VIEW_ORDER_SUCCESS =
  'GET_SHOP_MENU_VIEW_ORDER_SUCCESS';
export const GET_SHOP_MENU_VIEW_ORDER_FAILURE =
  'GET_SHOP_MENU_VIEW_ORDER_FAILURE';

export const GET_GOCHI_TIP_SUMMARY_REQUEST = 'GET_GOCHI_TIP_SUMMARY_REQUEST';
export const GET_GOCHI_TIP_SUMMARY_SUCCESS = 'GET_GOCHI_TIP_SUMMARY_SUCCESS';
export const GET_GOCHI_TIP_SUMMARY_FAILURE = 'GET_GOCHI_TIP_SUMMARY_FAILURE';

export const GET_GOCHI_TIP_URL_REQUEST = 'GET_GOCHI_TIP_URL_REQUEST';
export const GET_GOCHI_TIP_URL_SUCCESS = 'GET_GOCHI_TIP_URL_SUCCESS';
export const GET_GOCHI_TIP_URL_FAILURE = 'GET_GOCHI_TIP_URL_FAILURE';

export const CONFIRM_INVOICE_SHOP_REQUEST = 'CONFIRM_INVOICE_SHOP_REQUEST';
export const CONFIRM_INVOICE_SHOP_SUCCESS = 'CONFIRM_INVOICE_SHOP_SUCCESS';
export const CONFIRM_INVOICE_SHOP_FAILURE = 'CONFIRM_INVOICE_SHOP_FAILURE';

export const GET_INVOICE_HISTORY_SHOP_REQUEST =
  'GET_INVOICE_HISTORY_SHOP_REQUEST';
export const GET_INVOICE_HISTORY_SHOP_SUCCESS =
  'GET_INVOICE_HISTORY_SHOP_SUCCESS';
export const GET_INVOICE_HISTORY_SHOP_FAILURE =
  'GET_INVOICE_HISTORY_SHOP_FAILURE';

export const GET_INVOICE_SHOP_REQUEST = 'GET_INVOICE_SHOP_REQUEST';
export const GET_INVOICE_SHOP_SUCCESS = 'GET_INVOICE_SHOP_SUCCESS';
export const GET_INVOICE_SHOP_FAILURE = 'GET_INVOICE_SHOP_FAILURE';

export const GET_BATCH_SHOP_REQUEST = 'GET_BATCH_SHOP_REQUEST';
export const GET_BATCH_SHOP_SUCCESS = 'GET_BATCH_SHOP_SUCCESS';
export const GET_BATCH_SHOP_FAILURE = 'GET_BATCH_SHOP_FAILURE';

export const VALIDATE_BATCH_SHOP_REQUEST = 'VALIDATE_BATCH_SHOP_REQUEST';
export const VALIDATE_BATCH_SHOP_SUCCESS = 'VALIDATE_BATCH_SHOP_SUCCESS';
export const VALIDATE_BATCH_SHOP_FAILURE = 'VALIDATE_BATCH_SHOP_FAILURE';

export const ADD_BATCH_SHOP_IMPORT_FILE_REQUEST =
  'ADD_BATCH_SHOP_IMPORT_FILE_REQUEST';
export const ADD_BATCH_SHOP_IMPORT_FILE_SUCCESS =
  'ADD_BATCH_SHOP_IMPORT_FILE_SUCCESS';
export const ADD_BATCH_SHOP_IMPORT_FILE_FAILURE =
  'ADD_BATCH_SHOP_IMPORT_FILE_FAILURE';

export const SEND_SHOP_REPORT_REQUEST = 'SEND_SHOP_REPORT_REQUEST';
export const SEND_SHOP_REPORT_SUCCESS = 'SEND_SHOP_REPORT_SUCCESS';
export const SEND_SHOP_REPORT_FAILURE = 'SEND_SHOP_REPORT_FAILURE';

export const GET_SETTING_GOCHI_KID_REQUEST = 'GET_SETTING_GOCHI_KID_REQUEST';
export const GET_SETTING_GOCHI_KID_SUCCESS = 'GET_SETTING_GOCHI_KID_SUCCESS';
export const GET_SETTING_GOCHI_KID_FAILURE = 'GET_SETTING_GOCHI_KID_FAILURE';

export const GET_REPORT_SHOP_REQUEST = 'GET_REPORT_SHOP_REQUEST';
export const GET_REPORT_SHOP_SUCCESS = 'GET_REPORT_SHOP_SUCCESS';
export const GET_REPORT_SHOP_FAILURE = 'GET_REPORT_SHOP_FAILURE';

export const UPDATE_SETTING_GOCHI_KID_REQUEST =
  'UPDATE_SETTING_GOCHI_KID_REQUEST';
export const UPDATE_SETTING_GOCHI_KID_SUCCESS =
  'UPDATE_SETTING_GOCHI_KID_SUCCESS';
export const UPDATE_SETTING_GOCHI_KID_FAILURE =
  'UPDATE_SETTING_GOCHI_KID_FAILURE';

export const DELETE_SETTING_GOCHI_KID_SHOP_REQUEST =
  'DELETE_SETTING_GOCHI_KID_SHOP_REQUEST';
export const DELETE_SETTING_GOCHI_KID_SHOP_SUCCESS =
  'DELETE_SETTING_GOCHI_KID_SHOP_SUCCESS';
export const DELETE_SETTING_GOCHI_KID_SHOP_FAILURE =
  'DELETE_SETTING_GOCHI_KID_SHOP_FAILURE';

export const UPDATE_GOCHI_KID_FLAG_SHOP_REQUEST =
  'PDATE_GOCHI_KID_FLAG_SHOP_REQUEST';
export const UPDATE_GOCHI_KID_FLAG_SHOP_SUCCESS =
  'PDATE_GOCHI_KID_FLAG_SHOP_SUCCESS';
export const UPDATE_GOCHI_KID_FLAG_SHOP_FAILURE =
  'PDATE_GOCHI_KID_FLAG_SHOP_FAILURE';

export const UPDATE_SHOP_SETTING_GOCHI_KID_UNLIMIT_REQUEST =
  'UPDATE_SHOP_SETTING_GOCHI_KID_UNLIMIT_REQUEST';
export const UPDATE_SHOP_SETTING_GOCHI_KID_UNLIMIT_SUCCESS =
  'UPDATE_SHOP_SETTING_GOCHI_KID_UNLIMIT_SUCCESS';
export const UPDATE_SHOP_SETTING_GOCHI_KID_UNLIMIT_FAILURE =
  'UPDATE_SHOP_SETTING_GOCHI_KID_UNLIMIT_FAILURE';

export const UPDATE_ALLOW_GAP_PAYMENT_REQUEST =
  'UPDATE_ALLOW_GAP_PAYMENT_REQUEST';
export const UPDATE_ALLOW_GAP_PAYMENT_SUCCESS =
  'UPDATE_ALLOW_GAP_PAYMENT_SUCCESS';
export const UPDATE_ALLOW_GAP_PAYMENT_FAILURE =
  'UPDATE_ALLOW_GAP_PAYMENT_FAILURE';

export const getShops = params => dispatch => {
  dispatch({ type: GET_SHOPS_REQUEST });
  return getShopsData(params)
    .then(response =>
      dispatch({
        type: GET_SHOPS_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_SHOPS_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const getShopMenuViewOrder = () => dispatch => {
  dispatch({ type: GET_SHOP_MENU_VIEW_ORDER_REQUEST });
  return getShopMenuViewOrderData()
    .then(response =>
      dispatch({
        type: GET_SHOP_MENU_VIEW_ORDER_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_SHOP_MENU_VIEW_ORDER_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const downloadShop = params => dispatch => {
  dispatch({ type: DOWNLOAD_SHOP_REQUEST });
  return downloadShopData(params)
    .then(response =>
      dispatch({
        type: DOWNLOAD_SHOP_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: DOWNLOAD_SHOP_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const downloadShopEs = params => dispatch => {
  dispatch({ type: DOWNLOAD_SHOP_ES_REQUEST });
  return downloadShopEsData(params)
    .then(response =>
      dispatch({
        type: DOWNLOAD_SHOP_ES_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: DOWNLOAD_SHOP_ES_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const getShopDetail = shopId => dispatch => {
  dispatch({ type: GET_SHOP_DETAIL_REQUEST });
  return getShopDetailData(shopId)
    .then(response =>
      dispatch({
        type: GET_SHOP_DETAIL_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_SHOP_DETAIL_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const addShop = params => dispatch => {
  dispatch({ type: ADD_SHOP_REQUEST });
  return addShopData(params)
    .then(response =>
      dispatch({
        type: ADD_SHOP_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: ADD_SHOP_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const editShop = (shopId, params) => dispatch => {
  dispatch({ type: EDIT_SHOP_REQUEST });
  return editShopData(shopId, params)
    .then(response =>
      dispatch({
        type: EDIT_SHOP_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: EDIT_SHOP_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const editShopBankAccount = (shopId, params) => dispatch => {
  dispatch({ type: EDIT_SHOP_BANK_ACCOUNT_REQUEST });
  return editShopBankAccountData(shopId, params)
    .then(response =>
      dispatch({
        type: EDIT_SHOP_BANK_ACCOUNT_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: EDIT_SHOP_BANK_ACCOUNT_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const releaseShop = shopId => dispatch => {
  dispatch({ type: RELEASE_SHOP_REQUEST });
  return releaseShopData(shopId)
    .then(response =>
      dispatch({
        type: RELEASE_SHOP_SUCCESS,
        payload: response.data
      })
    )
    .catch(error => {
      return dispatch({
        type: RELEASE_SHOP_FAILURE,
        payload: error.response,
        error: true
      });
    });
};

export const deleteShop = shopId => dispatch => {
  dispatch({ type: DELETE_SHOP_REQUEST });
  return deleteShopData(shopId)
    .then(response =>
      dispatch({
        type: DELETE_SHOP_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: DELETE_SHOP_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const addShopImage = (shopId, params) => dispatch => {
  dispatch({ type: ADD_SHOP_IMAGE_REQUEST });
  return addShopImageData(shopId, params)
    .then(response =>
      dispatch({
        type: ADD_SHOP_IMAGE_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: ADD_SHOP_IMAGE_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const downloadQrCode = shopId => dispatch => {
  dispatch({ type: DOWNLOAD_QRCODE_REQUEST });
  return downloadQrCodeData(shopId)
    .then(response =>
      dispatch({
        type: DOWNLOAD_QRCODE_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: DOWNLOAD_QRCODE_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const countShopEmail = email => dispatch => {
  dispatch({ type: COUNT_SHOP_EMAIL_REQUEST });
  return countShopEmailData({ email })
    .then(response =>
      dispatch({
        type: COUNT_SHOP_EMAIL_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: COUNT_SHOP_EMAIL_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const addRelationShop = params => dispatch => {
  dispatch({ type: ADD_RELATION_SHOP_REQUEST });
  return addRelationShopData(params)
    .then(response =>
      dispatch({
        type: ADD_RELATION_SHOP_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: ADD_RELATION_SHOP_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const addUnRelationShop = (groupId, shopId) => dispatch => {
  dispatch({ type: DELETE_RELATION_SHOP_REQUEST });
  return addUnRelationShopData(groupId, shopId)
    .then(response =>
      dispatch({
        type: DELETE_RELATION_SHOP_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: DELETE_RELATION_SHOP_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const getZipCode = zipcode => dispatch => {
  dispatch({ type: GET_ZIPCODE_REQUEST });
  return getZipCodeData(zipcode)
    .then(response =>
      dispatch({
        type: GET_ZIPCODE_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_ZIPCODE_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const getShopEs = params => dispatch => {
  dispatch({ type: GET_SHOPS_REQUEST });
  return getShopsDataEs(params)
    .then(response =>
      dispatch({
        type: GET_SHOPS_SUCCESS,
        payload: {
          shops: response.data.list,
          totalCount: response.data.count,
          limit: response.data.limit,
          offset: response.data.offset
        }
      })
    )
    .catch(error =>
      dispatch({
        type: GET_SHOPS_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const getPaymentSummary = params => dispatch => {
  dispatch({ type: GET_PAYMENT_SUMMARY_SHOP_REQUEST });
  return getPaymentSummaryShopData(params)
    .then(response =>
      dispatch({
        type: GET_PAYMENT_SUMMARY_SHOP_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_PAYMENT_SUMMARY_SHOP_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const sendMailPaymentDetailMonth = params => dispatch => {
  dispatch({ type: SEND_MAIL_PAYMENT_DETAIL_MONTH_REQUEST });
  return sendMailPaymentDetailMonthData(params)
    .then(response =>
      dispatch({
        type: SEND_MAIL_PAYMENT_DETAIL_MONTH_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: SEND_MAIL_PAYMENT_DETAIL_MONTH_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const linkPaymentShop = params => dispatch => {
  dispatch({ type: LINK_PAYMENT_SHOP_REQUEST });
  return linkPaymentShopData(params)
    .then(response =>
      dispatch({
        type: LINK_PAYMENT_SHOP_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: LINK_PAYMENT_SHOP_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const getGochiTipSummary = params => dispatch => {
  dispatch({ type: GET_GOCHI_TIP_SUMMARY_REQUEST });
  return getGochiTipSummaryData(params)
    .then(response =>
      dispatch({
        type: GET_GOCHI_TIP_SUMMARY_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_GOCHI_TIP_SUMMARY_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const getGochiTipUrl = () => dispatch => {
  dispatch({ type: GET_GOCHI_TIP_URL_REQUEST });
  return getGochiTipUrlData()
    .then(response =>
      dispatch({
        type: GET_GOCHI_TIP_URL_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_GOCHI_TIP_URL_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const getInvoiceHistoryShop = () => dispatch => {
  dispatch({ type: GET_INVOICE_HISTORY_SHOP_REQUEST });
  return getInvoiceHistoryShopData()
    .then(response =>
      dispatch({
        type: GET_INVOICE_HISTORY_SHOP_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_INVOICE_HISTORY_SHOP_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const getInvoiceShop = params => dispatch => {
  dispatch({ type: GET_INVOICE_SHOP_REQUEST });
  return getInvoiceShopData(params)
    .then(response =>
      dispatch({
        type: GET_INVOICE_SHOP_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_INVOICE_SHOP_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const confirmInvoiceShop = params => dispatch => {
  dispatch({ type: CONFIRM_INVOICE_SHOP_REQUEST });
  return confirmInvoiceShopData(params)
    .then(response =>
      dispatch({
        type: CONFIRM_INVOICE_SHOP_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: CONFIRM_INVOICE_SHOP_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const listBatchShop = params => dispatch => {
  dispatch({ type: GET_BATCH_SHOP_REQUEST });
  return listBatchShopData(params)
    .then(response =>
      dispatch({
        type: GET_BATCH_SHOP_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_BATCH_SHOP_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const validateBatchShop = params => dispatch => {
  dispatch({ type: VALIDATE_BATCH_SHOP_REQUEST });
  return validateBatchShopData(params)
    .then(response =>
      dispatch({
        type: VALIDATE_BATCH_SHOP_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: VALIDATE_BATCH_SHOP_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const batchShopImportFile = params => dispatch => {
  dispatch({ type: ADD_BATCH_SHOP_IMPORT_FILE_REQUEST });
  return batchShopImportFileData(params)
    .then(response =>
      dispatch({
        type: ADD_BATCH_SHOP_IMPORT_FILE_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: ADD_BATCH_SHOP_IMPORT_FILE_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const sendShopReport = (shopId, params) => dispatch => {
  dispatch({ type: SEND_SHOP_REPORT_REQUEST });
  return sendShopReportData(shopId, params)
    .then(response =>
      dispatch({
        type: SEND_SHOP_REPORT_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: SEND_SHOP_REPORT_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const updateSettingGochiKidShop = (shopId, params) => dispatch => {
  dispatch({ type: UPDATE_SETTING_GOCHI_KID_REQUEST });
  return updateSettingGochiKidShopData(shopId, params)
    .then(response =>
      dispatch({
        type: UPDATE_SETTING_GOCHI_KID_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: UPDATE_SETTING_GOCHI_KID_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const getSettingGochiKidShop = params => dispatch => {
  dispatch({ type: GET_SETTING_GOCHI_KID_REQUEST });
  return getSettingGochiKidShopData(params)
    .then(response =>
      dispatch({
        type: GET_SETTING_GOCHI_KID_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_SETTING_GOCHI_KID_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const getReportShop = (shopId, month) => dispatch => {
  dispatch({ type: GET_REPORT_SHOP_REQUEST });
  return getReportShopData(shopId, month)
    .then(response =>
      dispatch({
        type: GET_REPORT_SHOP_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_REPORT_SHOP_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const deleteSettingGochiKidShop = shopId => dispatch => {
  dispatch({ type: DELETE_SETTING_GOCHI_KID_SHOP_REQUEST });
  return deleteSettingGochiKidShopData(shopId)
    .then(response =>
      dispatch({
        type: DELETE_SETTING_GOCHI_KID_SHOP_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: DELETE_SETTING_GOCHI_KID_SHOP_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const updateGochiKidFlagShop = (shopId, params) => dispatch => {
  dispatch({ type: UPDATE_GOCHI_KID_FLAG_SHOP_REQUEST });
  return updateGochiKidFlagShopData(shopId, params)
    .then(response =>
      dispatch({
        type: UPDATE_GOCHI_KID_FLAG_SHOP_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: UPDATE_GOCHI_KID_FLAG_SHOP_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const updateShopSettingGochiKidUnlimit = (
  shopId,
  params
) => dispatch => {
  dispatch({ type: UPDATE_SHOP_SETTING_GOCHI_KID_UNLIMIT_REQUEST });
  return updateShopSettingGochiKidUnlimitData(shopId, params)
    .then(response =>
      dispatch({
        type: UPDATE_SHOP_SETTING_GOCHI_KID_UNLIMIT_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: UPDATE_SHOP_SETTING_GOCHI_KID_UNLIMIT_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const updateAllowGapPayment = params => dispatch => {
  dispatch({ type: UPDATE_ALLOW_GAP_PAYMENT_REQUEST });
  return updateAllowGapPaymentData(params)
    .then(response =>
      dispatch({
        type: UPDATE_ALLOW_GAP_PAYMENT_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: UPDATE_ALLOW_GAP_PAYMENT_FAILURE,
        payload: error.response,
        error: true
      })
    );
};
